export default {
  money: function (val) {
    val = typeof val ==='number' ? val : 0
    return (parseFloat(val) / 100).toFixed(2)
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatter.js